export const customerPaths = {
    customers: 'customers',
    customersAdd: 'customers/add',
    customersSettings: 'customers/settings',
};
